import { render, staticRenderFns } from "./Joining.vue?vue&type=template&id=5b1fec7e&scoped=true"
import script from "./Joining.vue?vue&type=script&lang=js"
export * from "./Joining.vue?vue&type=script&lang=js"
import style0 from "./Joining.vue?vue&type=style&index=0&id=5b1fec7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fec7e",
  null
  
)

export default component.exports